export default __webpack_public_path__ + "static/swim-c375d532fd0a1322b5442a09ba8031df.png";